import { render, staticRenderFns } from "./AdminMandateSuspensionForm.vue?vue&type=template&id=64f8deca&scoped=true&"
import script from "./AdminMandateSuspensionForm.vue?vue&type=script&lang=js&"
export * from "./AdminMandateSuspensionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f8deca",
  null
  
)

export default component.exports